import React, { useState } from 'react'
import { useTranslations } from '../../hooks/useTranslations'
import FormProgressOverlay from '../organisms/FormProgressOverlay'

const M28SalesforceForm = ({ anchorLinkId }) => {
  const translations = useTranslations()
  const successParam =
    typeof window !== 'undefined'
      ? new URLSearchParams(window.location.search).get('success')
      : null
  const [formState, setFormState] = useState(
    successParam ? 'success' : 'default',
  )
  const [currentUrl] = useState(() =>
    typeof window !== 'undefined' ? window.location.href : 'https://lift.ch',
  )

  return (
    <>
      <FormProgressOverlay
        state={formState}
        initialTimeout={5}
        onClose={() => setFormState('default')}
      />
      <section className="my-10 overflow-hidden md:my-20" id={anchorLinkId}>
        <div className="container">
          <div className="row-type-g">
            <div className="col-1-type-g3">
              <div className="column-indent-both">
                <form
                  action="https://test.salesforce.com/servlet/servlet.WebToLead?encoding=UTF-8&orgId=00DFT000003MPCZ"
                  method="POST"
                  className="pb-16 salesforce-form"
                >
                  {/* Hidden Fields */}
                  <input type="hidden" name="oid" value="00DFT000003MPCZ" />
                  <input type="hidden" name="lead_source" value="01" />
                  <input
                    type="hidden"
                    name="Campaign_ID"
                    value="701FT00000MaqDCYAZ"
                  />
                  <input type="hidden" name="00Nc4000000idkC" value="1500" />
                  <input type="hidden" name="00Nc4000000idk9" value="DE" />
                  <input type="hidden" name="country" value="CH" />
                  <input
                    type="hidden"
                    name="recordType"
                    value="012FT0000011cYw"
                  />
                  <input type="hidden" name="00Nc4000000idkf" value="1" />
                  <input
                    type="hidden"
                    name="retURL"
                    value={`${currentUrl}?success=true`}
                  />
                  <input
                    type="hidden"
                    name="00NFT0000030opz"
                    value={`${currentUrl}?success=true`}
                  />

                  {/* Form Fields */}
                  <div className="form-columns-1">
                    <label htmlFor="company">{translations.company}</label>
                    <input
                      id="company"
                      maxLength="70"
                      name="company"
                      size="20"
                      type="text"
                      required
                    />
                  </div>

                  <div className="form-columns-1">
                    <label htmlFor="salutation">
                      {translations.salutation}
                    </label>
                    <select id="salutation" name="salutation">
                      <option value="">{translations.noSelection}</option>
                      <option value="0002">{translations.mr}</option>
                      <option value="0032">{translations.mrs}</option>
                    </select>
                  </div>

                  <div className="form-columns-1">
                    <label htmlFor="first_name">{translations.firstName}</label>
                    <input
                      id="first_name"
                      maxLength="40"
                      name="first_name"
                      size="20"
                      type="text"
                      required
                    />
                  </div>

                  <div className="form-columns-1">
                    <label htmlFor="last_name">{translations.lastName}</label>
                    <input
                      id="last_name"
                      maxLength="80"
                      name="last_name"
                      size="20"
                      type="text"
                      required
                    />
                  </div>

                  <div className="form-columns-1">
                    <label htmlFor="email">{translations.email}</label>
                    <input
                      id="email"
                      maxLength="80"
                      name="email"
                      size="20"
                      type="email"
                      required
                    />
                  </div>

                  <div className="form-columns-1">
                    <label htmlFor="phone">{translations.phoneNumber}</label>
                    <input
                      id="phone"
                      maxLength="40"
                      name="phone"
                      size="20"
                      type="text"
                    />
                  </div>

                  <div className="form-columns-1">
                    <label htmlFor="00NFT000003e0Sm">
                      {translations.function}
                    </label>
                    <input
                      id="00NFT000003e0Sm"
                      maxLength="255"
                      name="00NFT000003e0Sm"
                      size="20"
                      type="text"
                    />
                  </div>

                  <div className="form-columns-1">
                    <label htmlFor="00NFT000003e0Sn">
                      {translations.customerNumber}
                    </label>
                    <input
                      id="00NFT000003e0Sn"
                      maxLength="10"
                      name="00NFT000003e0Sn"
                      size="20"
                      type="text"
                    />
                  </div>

                  <div className="form-columns-1">
                    <label htmlFor="description">{translations.message}</label>
                    <textarea id="description" name="description" required />
                  </div>

                  <div className="form-columns-1">
                    <label htmlFor="street">{translations.street}</label>
                    <textarea id="street" name="street" wrap="soft" />
                  </div>

                  <div className="form-columns-1">
                    <label htmlFor="city">{translations.city}</label>
                    <input
                      id="city"
                      maxLength="40"
                      name="city"
                      size="20"
                      type="text"
                      required
                    />
                  </div>

                  <div className="form-columns-1">
                    <label htmlFor="zip">{translations.zip}</label>
                    <input
                      id="zip"
                      maxLength="20"
                      name="zip"
                      size="20"
                      type="text"
                      required
                    />
                  </div>

                  {/* Marketing Consent */}
                  <div className="form-columns-1">
                    <p>{translations.privacy}</p>
                    <div className="pt-8 flex items-start">
                      <input
                        id="00Nc4000000idkn"
                        name="00Nc4000000idkn"
                        type="checkbox"
                        value="1"
                      />
                      <label htmlFor="00Nc4000000idkn">
                        {translations.confirmMarketing}
                      </label>
                    </div>
                    <p>{translations.unsubscribe}</p>
                  </div>

                  <div className="pt-8">
                    <button
                      type="submit"
                      className="hs-submit hs-button primary large"
                    >
                      {translations.send}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default M28SalesforceForm
